import React from 'react';
import { useSelector } from 'react-redux';

import MeshbotRunCell from './MeshbotRunCell';
import useLocalMeshBotRunState from 'hooks/useLocalMeshBotRunState';
import { shouldDisableSystemTcdsActions } from 'containers/Ezlo/EzloMeshbot/utils';
import { ADVANCED_SCENES } from 'constants/ControllerFeatures';
import { EZLOGIC_TITLE_RUN_MESHBOT_FROM_ADVANCED_SCENE_1_74 } from 'constants/language_tokens';
import { Tooltip } from 'components';
import { useTranslate } from 'features/languages';

const LocalMeshbotRun = ({ id, serial, isDisabled, status, runScene, meshbotType }) => {
    const { t } = useTranslate();
    const { isButton, isButtonDisabled, handleButtonClick } = useLocalMeshBotRunState({ id, serial, status, runScene });

    const params = { meshbotType, serial };
    const ezloData = useSelector((state) => state.ezlo?.data?.[params?.serial]);
    const isTcdsDisabled = shouldDisableSystemTcdsActions(params, ezloData, ADVANCED_SCENES.VERSION_1_74);
    
    return (
        <Tooltip
            title={
                isTcdsDisabled ? (
                    <div dangerouslySetInnerHTML={{ __html: t(EZLOGIC_TITLE_RUN_MESHBOT_FROM_ADVANCED_SCENE_1_74) }} />
                ) : (
                    ''
                )
            }
            position="top"
        >
            <div>
                <MeshbotRunCell
                    handleButtonClick={handleButtonClick}
                    status={status}
                    isButton={isButton}
                    isDisabled={isDisabled || isButtonDisabled || isTcdsDisabled}
                />
            </div>
        </Tooltip>
    );
};

export default LocalMeshbotRun;
